import React from 'react';

import { UiKit } from 'components';
import { useNotifications } from 'utils/hooks';

export default function MarkAllAsRead() {
  const { markAllAsRead, isReadingNotification } = useNotifications();

  return (
    <UiKit.Button
      variant="outline"
      onClick={markAllAsRead}
      disabled={isReadingNotification}
    >
      Mark all as read
    </UiKit.Button>
  );
}
